module.exports = __webpack_public_path__ + "static/img/support-headshot.b385e0d9.jpg";